import React from "react";
import {useMediaQuery} from "react-responsive";
import {Button} from "reactstrap";
import ProtectedContent from "../../../components/protectedContent";

const SummaryHeader = ({ioTypes, modalHandler}) => {
  const isMobileOrTablet = useMediaQuery({query: "(max-width: 1080px)"});

  return (
    <ProtectedContent perms={["add_inventorysensors"]}>
      <div style={{paddingBottom: isMobileOrTablet ? "0px" : "15px"}}></div>
      <div
        style={{
          display: "flex",
          padding: isMobileOrTablet ? "10px 10px 0px 0px" : "10px 20px 0px 0px",
          justifyContent: "flex-end",
          position: isMobileOrTablet ? "static" : "absolute",
          top: "10px",
          right: "0px",
        }}
      >
        {ioTypes.map((ioType) => (
          <Button
            key={ioType.value}
            onClick={() => modalHandler(ioType.value)}
            className="btn_common roboto-bold"
            data-cy={`ADD_${ioType.label}`}
          >
            {`ADD ${ioType.label}`}
          </Button>
        ))}
      </div>
    </ProtectedContent>
  );
};

export default SummaryHeader;
